import React, { useRef } from "react";
import { MarqueeMode, useConstantMarqueeSpeed } from "./useConstantMarqueeSpeed";

type MarqueeTextProps = {
  text: string;
  className?: string;
  contentClassName?: string;
  mode?: MarqueeMode;
};

const MarqueeText: React.FC<MarqueeTextProps> = ({
  text,
  className,
  contentClassName = "notifi-mssage",
  mode = "pass",
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLSpanElement>(null);
  useConstantMarqueeSpeed(containerRef, contentRef, Boolean(text), text, mode);
  if (!text) return null;
  return (
    <div ref={containerRef} className={["marque-new", className].filter(Boolean).join(" ")}>
      <span ref={contentRef} className={["marque-new__content", contentClassName].filter(Boolean).join(" ")}>
        {text}
      </span>
    </div>
  );
};
export default MarqueeText;
